import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // Importa jwt-decode

// Crea una instancia de Axios
const api = axios.create({
  baseURL: "https://back-projectumg.ervinsantos.com/api", 
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para añadir el token a todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token && !["/auth/login", "/auth/register"].includes(config.url)) {
      // Validar si el token ha expirado
      if (isTokenExpired()) {
        // Si el token ha expirado, eliminarlo y redirigir al login
        removeToken();
        //const navigate = useNavigate();
        //navigate("/");
        window.location.href = "/login"; // Redirige al login
        throw new Error("Token ha expirado, redirigiendo al login");
      }
      // Añadir el token al header si no ha expirado
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para gestionar errores de respuesta
api.interceptors.response.use(
  (response) => response, // Devuelve la respuesta si es exitosa
  (error) => {
    const navigate = useNavigate();
    let status = error.response ? error.response.status : error;
    console.log("status", status);
    if (status == 401 || status == 403) {
      console.log("tiene que redirigir");
      // Si el token ha expirado o no es válido
      removeToken(); // Elimina el token
      //navigate("/token"); // Redirige al login

      window.location.href = "/login"; // Redirige al login
      throw new Error("Token ha expirado, redirigiendo al login");
    }

    return Promise.reject(error);
  }
);

export const getToken = () => {
  return localStorage.getItem("token"); // O donde sea que estés almacenando el JWT
};

export const setToken = (token) => {
  localStorage.setItem("token", token);
};

export const removeToken = () => {
  console.log("elimina token");
  localStorage.removeItem("token");
};

// Función para verificar si el token ha expirado
export const isTokenExpired = () => {
  try {
    const token = getToken();
    if (!token) {
      return true; // Si no hay token, se considera como expirado
    }

    const decodedToken = jwtDecode(token); // Decodifica el token
    const currentTime = Date.now() / 1000; // Tiempo actual en segundos

    return decodedToken.exp < currentTime; // Si la expiración es menor al tiempo actual, el token ha expirado
    //return true;
  } catch (error) {
    return true; // Si no se puede decodificar, considerar el token inválido o expirado
  }
};

// Funciones para las llamadas a la API

// Login
export const login = async (credentials) => {
  try {
    const response = await api.post("/auth/login", credentials);
    return response.data; // Aquí obtendrás el token
  } catch (error) {
    throw error.response.data;
  }
};

// Registro
export const register = async (userData) => {
  try {
    const response = await api.post("/auth/register", userData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// ============ PROJECT ===================

// Obtener todos los proyectos
export const getProjects = async () => {
  try {
    const response = await api.get("/project");
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Crear un nuevo proyecto
export const createProject = async (projectData) => {
  try {
    const response = await api.post("/project", projectData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Obtener proyecto por ID
export const getProjectById = async (id) => {
  try {
    const response = await api.get(`/project/${id}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Actualizar proyecto
export const updateProject = async (id, projectData) => {
  try {
    const response = await api.put(`/project/${id}`, projectData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Eliminar proyecto
export const deleteProject = async (id) => {
  try {
    const response = await api.delete(`/project/${id}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// ============ TEST ===================

// Obtener todos los casos de prueba
export const getTests = async () => {
  try {
    const response = await api.get("/test");
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Obtener todos los casos de prueba de un proyecto
export const getTestsByProjectId = async (projectId) => {
  try {
    const response = await api.get(`/test/project/${projectId}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Crear un nuevo caso de prueba
export const createTest = async (testData) => {
  try {
    const response = await api.post(`/test`, testData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Obtener caso de prueba por ID
export const getTestById = async (projectId, testId) => {
  try {
    const response = await api.get(`/test/${testId}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Actualizar caso de prueba
export const updateTest = async (testId, testData) => {
  try {
    const response = await api.put(`/test/${testId}`, testData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Eliminar caso de prueba
export const deleteTest = async (testId) => {
  try {
    const response = await api.delete(`/test/${testId}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// ============ USER ===================
// Obtener todos los usuarios
export const getUsers = async () => {
  try {
    const response = await api.get("/user"); // Ajusta la ruta según tu API
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Crear un nuevo usuario
export const createUser = async (userData) => {
  try {
    const response = await api.post("/user", userData); // Ajusta la ruta según tu API
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Obtener usuario por ID
export const getUserById = async (id) => {
  try {
    const response = await api.get(`/user/${id}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Actualizar usuario
export const updateUser = async (id, userData) => {
  try {
    const response = await api.put(`/user/${id}`, userData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Eliminar usuario
export const deleteUser = async (id) => {
  try {
    const response = await api.delete(`/user/${id}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// ============ DEFECT ===================

// Obtener todos los defectos
export const getDefects = async () => {
  try {
    const response = await api.get("/defect");
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Obtener defecto por ID
export const getDefectById = async (id) => {
  try {
    const response = await api.get(`/defect/${id}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Crear un nuevo defecto
export const createDefect = async (defectData) => {
  try {
    const response = await api.post("/defect", defectData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Actualizar un defecto existente
export const updateDefect = async (id, defectData) => {
  try {
    const response = await api.put(`/defect/${id}`, defectData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Eliminar un defecto
export const deleteDefect = async (id) => {
  try {
    const response = await api.delete(`/defect/${id}`);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export default api;
